// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M7.35 14.5H5.02C3.91 14.5 3.02 13.6 3.02 12.5V2.99C3.02 2.17 3.68 1.5 4.51 1.5H6.52C7.21 1.5 7.88 1.61 8.51 1.81M12.98 7.34C12.95 7.05 12.91 6.77 12.84 6.5C12.32 4.28 10.66 2.5 8.51 1.81M8.51 1.81V4.5C8.51 5.6 9.41 6.5 10.51 6.5H12.84',
  'M14 10.6L11.2 13.4L10 12.2',
];
